// removed by extract-text-webpack-plugin
module.exports = {"Layout":"Layout__Layout__2C2_c","LeftSide":"Layout__LeftSide__1XXtN","RightSide":"Layout__RightSide__2eZpf","RightSideInner":"Layout__RightSideInner__1lvPj","SpinnerToMiddle":"Layout__SpinnerToMiddle__3BwCB","CopyrightLine":"Layout__CopyrightLine__YHJKA"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.css
// module id = 187
// module chunks = 6